import { FC, ReactNode } from 'react';
import { Card } from 'antd';
import classnames from 'classnames';

import s from './index.module.scss';

type SettingsCardProps = {
	title: string | JSX.Element;
	children: ReactNode;
	extra?: ReactNode;
	className?: string;
};
export const SettingsCard: FC<SettingsCardProps> = ({ children, title, extra, className }) => {
	return (
		<Card title={title} className={classnames(s.card, className)} extra={extra}>
			{children}
		</Card>
	);
};
